import { appResumed, clearPushNotification, setUnreadCount, storePushNotification, } from 'redux/notifications/actions';
import { initialState } from 'redux/notifications/initialState';
import { createReducer } from 'typesafe-actions';
// noinspection TypeScriptValidateJSTypes
export const reducer = createReducer(initialState)
    .handleAction(storePushNotification, (state, action) => (Object.assign(Object.assign({}, state), { notification: action.payload })))
    .handleAction(clearPushNotification, (state) => (Object.assign(Object.assign({}, state), { notification: undefined })))
    .handleAction(appResumed, (state, action) => (Object.assign(Object.assign({}, state), { resumeAt: action.payload })))
    .handleAction(setUnreadCount, (state, action) => (Object.assign(Object.assign({}, state), { unreadCount: action.payload })));
